module.exports = __webpack_public_path__ + "img/20200204_191050.94b75129.jpg";